'use client';

import { Chip } from '@coolblue-development/freddy';
import { HomeOutlined } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';

type Props = {
  onClick?: () => void;
};

export const RelocationChip = ({ onClick }: Props) => {
  const { t } = useTranslation('vacancyDetail.header.relocation');

  return (
    <Chip variant={onClick ? 'button' : undefined} onClick={onClick} startIcon={<HomeOutlined />}>
      {t('relocationChipText')}
    </Chip>
  );
};
